export default "__VITE_ASSET__Z7t35Iyt__"